// HSV is used so we can interpolate colors on the GPU given a min/max range
type HSV = [number, number, number];

export interface PointCloudPalette {
  withoutIntensity: HSV;
  min: HSV;
  max: HSV;
}

export const groundPalette: PointCloudPalette = {
  withoutIntensity: [256 / 360, 1, 1],
  min: [280 / 360, 1, 1],
  max: [1, 1, 1],
};

export const cloudPalette: PointCloudPalette = {
  withoutIntensity: [0, 0, 1],
  min: [0.61, 1, 1],
  max: [1 / 360, 1, 1],
};
